<template>
  <div>
    <mu-stepper :activeStep="activeStep">
      <mu-step>
        <mu-step-label>
          {{$t('message.gettingStartedTabYou')}}
        </mu-step-label>
      </mu-step>
      <mu-step>
        <mu-step-label>
          {{$t('message.gettingStartedTabHealth')}}
        </mu-step-label>
      </mu-step>
      <mu-step>
        <mu-step-label>
          {{$t('message.gettingStartedTabLocation')}}
        </mu-step-label>
      </mu-step>
      <mu-step>
        <mu-step-label>
          {{$t('message.gettingStartedTabGoals')}}
        </mu-step-label>
      </mu-step>
      <mu-step>
        <mu-step-label>
          {{$t('message.gettingStartedTabPersonalise')}}
        </mu-step-label>
      </mu-step>
    </mu-stepper>
    <mu-card>
      <div v-show="isLoading">
        <mu-card-text align="center">
          <img src="static/Dashboard.gif" width="25%"/>
          <br/>
          {{$t('message.loadingText')}}
        </mu-card-text>
      </div>
      <div v-show="!isLoading && $store.state.list.diabetes_types">
        <mu-card-header
          :title="title"
          :subTitle="subTitle"
        ></mu-card-header>
        <mu-card-text>
          <div>
            <mu-row>
              <mu-col desktop="70" tablet="70">
                <mu-select-field
                  id="diagnosisYearTxt"
                  v-if="isDiabetic"
                  v-validate
                  :data-vv-rules="'required'"
                  data-vv-name="diagnosis_year"
                  data-vv-value-path="inputValue"
                  :data-vv-as="$t('message.accountPreferencesDiagnosisYear')"
                  :errorText="errors.first('diagnosis_year')"
                  :underlineShow="underlineShow"
                  :fullWidth="fullWidth"
                  :maxHeight="300"
                  :hintText="$t('message.selectText')"
                  v-model="model.diagnosis_year"
                  :label="$t('message.accountPreferencesDiagnosisYear')"
                >
                  <mu-menu-item
                    v-for="(item, index) in yearList()"
                    v-if="moment(model.dob).format('Y') <= item"
                    :key="'diagnosis-year-' + index"
                    :value="item"
                    :title="item"
                  ></mu-menu-item>
                </mu-select-field>
              </mu-col>
            </mu-row>
          </div>
          <div>
            <h2 style="padding-top:0; margin-top: 0px;">{{$t('message.gettingStartedHealthCheckRelevantBoxes')}}</h2>
          </div>
          <div style="padding-top: 0; padding-bottom:0">
            <mu-checkbox
              id="healthConditionChk"
              v-model="model.has_other_conditions"
              :label="isDiabetic ? $t('message.gettingStartedHealthDoYouHaveAnyOtherConditions') : $t('message.gettingStartedHealthDoYouHaveAnyConditions')"></mu-checkbox>
          </div>
          <div v-show="model.has_other_conditions">
            <mu-row>
              <mu-col desktop="70" tablet="100" width="100">
                <div id="conditions"  style="position: relative">
                  <mu-auto-complete
                    id="conditionSearchingTxt"
                    :scroller="scroller"
                    inputClass="conSearchInput"
                    :openOnFocus="!conditionSearching"
                    :fullWidth="true"
                    @change="handleConditionSelected"
                    :hintText="conditionHelpText"
                    v-model="conditionSearchValue"
                    :maxSearchResults="10"
                    :dataSource="conditionDataSource"
                    :dataSourceConfig="conditionDataSourceConfig"
                    :maxHeight="250"
                    filter="noFilter"/>

                    <mu-circular-progress v-if="conditionSearching" style="position: absolute;top: 0px;right: 0px;height: 16px;width: 16px;"  :size="16"></mu-circular-progress>

                </div>
              </mu-col>
            </mu-row>
            <mu-chip
              v-for="(item, index) in model.user_conditions"
              :key="'condition-' + index">
              <mu-icon value="delete" @click.native="handleConditionRemoval(item)"></mu-icon>
              {{item.condition_label}}
            </mu-chip>
            <div class="dashedBorder"></div>
          </div>
          <div>
            <mu-checkbox id="takesMedicationChk" v-model="model.takes_medication" :label="$t('message.accountPreferencesTakeMedication')"></mu-checkbox>
          </div>
          <div v-show="model.takes_medication">
            <mu-row>
              <mu-col desktop="70" tablet="100" width="100">
                <div ref="medications" class="mediSearch" id="medications" style="position: relative">
                  <mu-auto-complete
                    id="medicationSearchTxt"
                    :scroller="scroller"
                    inputClass="mediSearchInput"
                    @change="handleMedicationSelected"
                    :openOnFocus="!medicationSearching"
                    :dataSource="medicationDataSource"
                    :dataSourceConfig="medicationDataSourceConfig"
                    :fullWidth="true"
                    v-model="medicationSearchValue"
                    :maxSearchResults="10"
                    :hintText="$t('message.gettingStartedHealthTypeMedication')"
                    :maxHeight="250"
                    filter="noFilter"/>

                  <mu-circular-progress v-if="medicationSearching" style="position: absolute;top: 0px;right: 0px;height: 16px;width: 16px;"  :size="16"></mu-circular-progress>

                </div>
              </mu-col>
            </mu-row>
          </div>
          <mu-row>
            <mu-col desktop="70" tablet="100" width="100">
              <mu-list v-show="model.takes_medication" style="padding-bottom: 0;padding-left:0;padding-right: 0"
                       v-if="model.user_medications.length > 0"
                       id="medication-list">
                <mu-list-item
                  style="padding-bottom:0;padding-left:0;padding-right: 0"
                  disableRipple
                  v-for="treatment, index in model.user_medications"
                  :key="'treatment-' + index"
                  :title="treatment.treatment_name"
                >
                  <mu-row gutter slot="default" style="margin-top: 8px;">
                    <mu-col width="50" desktop="70" tablet="50">
                      <mu-select-field
                        id="treatmentSelectTxt"
                        :hintText="$t('message.selectText')"
                        v-validate
                        :data-vv-name="treatment.treatment_name + '_unit_' + index"
                        data-vv-rules="required"
                        data-vv-value-as="inputValue"
                        data-vv-validate-on="none"
                        :errorText="errors.first(treatment.treatment_name + '_unit_' + index)"
                        @change="reformatMedications"
                        :maxHeight="250"
                        fullWidth
                        :label="$t('message.labelUnits')"
                        autoWidth
                        v-model="treatment.unit_id"
                      >
                        <mu-menu-item
                          v-for="item, index in medicationUnitRegimes"
                          :key="'unit-regime-' + index"
                          :title="localizeRegime(item.unit_label)"
                          :value="item.unit_id">
                        </mu-menu-item>
                      </mu-select-field>
                    </mu-col>
                    <mu-col width="50" desktop="30" tablet="50">
                      <mu-select-field
                        id="treatmentFrequencyTxt"
                        :hintText="$t('message.selectText')"
                        v-validate
                        :data-vv-name="treatment.treatment_name + '_freq_' + index"
                        data-vv-rules="required"
                        data-vv-value-as="inputValue"
                        data-vv-validate-on="none"
                        :errorText="errors.first(treatment.treatment_name + '_freq_' + index)"
                        @change="reformatMedications"
                        :maxHeight="250"
                        fullWidth
                        :label="$t('message.labelHowOften')"
                        autoWidth
                        v-model="treatment.frequency_id"
                      >
                        <mu-menu-item
                          v-for="item, index in medicationFrequencyRegimes"
                          :key="'regime-frequency-' + index"
                          :title="$t(localizeFrequency(item.frequency_label))"
                          :value="item.frequency_id">
                        </mu-menu-item>
                      </mu-select-field>
                    </mu-col>
                  </mu-row>
                  <mu-icon slot="right" value="delete" @click.native="handleMedicationDeleted(treatment)"/>
                </mu-list-item>
                <div class="dashedBorder" style="margin-top: 8px;"></div>
              </mu-list>
            </mu-col>
          </mu-row>
          <div v-if="isDiabetic" style="padding-top: 0">
            <mu-checkbox id="testBloodChk" v-model="model.tests_blood" :label="$t('message.accountPreferencesTestBlood')"></mu-checkbox>
          </div>

          <div>
            <mu-checkbox id="smokesCigarettesChk" v-model="model.smokes_cigarettes" :label="$t('message.accountSmokesCigarettes')"></mu-checkbox>

            <div v-if="model.smokes_cigarettes">
              <mu-text-field
                :label="$t('message.accountCigarettesPerDay')"
                type="number"
                v-model="model.cigarettes_per_day"
                v-validate
                :data-vv-rules="'required'"
                data-vv-name="cigarettes_per_day"
                data-vv-value-path="inputValue"
                :data-vv-as="$t('message.accountCigarettesPerDay')"
                :errorText="errors.first('cigarettes_per_day')"
                :underlineShow="underlineShow"
                :fullWidth="fullWidth"
                :maxHeight="300"
                :hintText="$t('message.placeholderText')"

              ></mu-text-field>
            </div>

          </div>


          <br/>
          <mu-raised-button
            id="submitBtn"
            :fullWidth="true"
            secondary
            backgroundColor="#9ACA3F"
            color="white"
            :label="isSaving ? $t('message.savingText'): $t('message.nextText')"
            :disabled="isSaving"
            @click.native="submitForm"
          >
          </mu-raised-button>
        </mu-card-text>
      </div>
    </mu-card>
  </div>
</template>
<script>

  import MedicationRegimeLocalizerMixin from '../../mixins/Localization/MedicationRegimes'
  import MedicationFrequencyLocalizerMixin from '../../mixins/Localization/MedicationFrequencies'

  import AccountApi from '../../api/Account'
  import MedicationsApi from '../../api/Tracking/Medication/index'
  import ScrollerMixin from '../../mixins/ScrollerMixin'

  import {Observable} from 'rxjs/Rx'

  export default {
    name: 'health',
    mixins: [ScrollerMixin, MedicationRegimeLocalizerMixin, MedicationFrequencyLocalizerMixin],
    data () {
      return {
        scroller: document.body,
        moment: moment,
        activeStep: 1,
        isDiabetic: false,
        title: this.$t('message.gettingStartedHealthTitle'),
        subTitle: this.$t('message.gettingStartedHealthSubTitle'),
        isSaving: false,
        isLoading: true,
        activeDiabetesType: {},
        conditionSearchValue: '',
        conditionSearching: false,
        conditionHelpText: this.$t('message.gettingStartedHealthTypeCondition'),
        medicationSearchValue: '',
        medicationSearching: false,
        medicationHelpText: 'Type a medication to add it',
        fullWidth: true,
        underlineShow: true,
        lists: {},
        model: {
          user_conditions: [],
          user_medications: [],
          smokes_cigarettes: false,
          has_other_conditions: false,
          takes_medication: false,
          diabetes_type_id: null
        },
        conditionDataSource: [],
        conditionDataSourceConfig: {
          text: 'condition_label',
          value: 'condition_id',
        },
        medicationDataSource: [],
        medicationDataSourceConfig: {
          text: 'treatment_name',
          value: 'treatment_id'
        },
        medicationUnitRegimes: [],
        medicationFrequencyRegimes: []
      }
    },
    watch: {
      'model.has_other_conditions': function () {
        let self = this;
        self.$forceUpdate();
      },
      'model.diabetes_type_id': function (newValue, oldValue) {
        let self = this;
        self.lists = JSON.parse(JSON.stringify(self.$store.state.list));
        if (newValue != null) {
          self.activeDiabetesType = self.lists.diabetes_types.filter(function (type) {
            return type.diabetes_type_id == newValue
          })[0];
          if (_.has(self.activeDiabetesType, 'is_diabetic')) {
            if (self.activeDiabetesType.is_diabetic == true) {
              self.isDiabetic = true
            }
            else {
              self.isDiabetic = false
            }
          }
        }
      }
    },
    mounted () {
      let self = this;
      self.$gtag.pageview('/getting-started/your-health');

      let medicationInputElement = $('.mediSearchInput');
      let conditionInputElement = $('.conSearchInput');

      Observable.fromEvent(medicationInputElement, 'input').map(x => x.currentTarget.value)
        .debounceTime(250)
        .subscribe(function (eventText) {
          self.handleMedicationSearch(eventText)
        });

      Observable.fromEvent(conditionInputElement, 'input').map(x => x.currentTarget.value)
        .debounceTime(250)
        .subscribe(function (eventText) {
          self.handleConditionSearch(eventText)
        });

      //Load getting started list
      AccountApi.getUserConditions()
        .then(function (response) {
          if (response.data.length > 0) {
            self.model.has_other_conditions = true;
            self.model.user_conditions = response.data;
            self.$forceUpdate()
          }
          else {
            self.model.has_other_conditions = false;
            self.model.user_conditions = [];
            self.$forceUpdate()
          }
        });
      //Load user account
      AccountApi.getAccount().then(function (response) {
        self.lists = self.$store.state.list;
        $.extend(self.model, response.data);
        self.model.diabetes_type_id = response.data.diabetes_type_id;
        self.model.diagnosis_year = '' + response.data.diagnosis_year + '';
        if (self.model.diagnosis_year == '0') {
          self.model.diagnosis_year = null
        }
        setTimeout(function () {
          self.isLoading = false
        }.bind(self), 500);
        //Load medication unit regimes
        MedicationsApi.regimeUnitsGet().then(function (response) {
          for (let i = 0; i < response.data.length; i++) {
            let unit = {
              'unit_id': response.data[i].ID,
              'unit_label': response.data[i].regimeUnitLabel
            };
            self.medicationUnitRegimes.push(unit)
          }
        });
        //Load medication frequency regimes
        MedicationsApi.regimeFrequencysGet().then(function (response) {
          for (let i = 0; i < response.data.length; i++) {
            let frequency = {
              'frequency_id': response.data[i].ID,
              'frequency_label': response.data[i].frequency
            };
            self.medicationFrequencyRegimes.push(frequency)
          }
        })
      })
        .catch(function (error) {
          self.$router.push({
            name: 'Login'
          })
        })
    },
    methods: {
      submitForm () {
        let self = this;
        self.$validator.validateAll()
          .then(function (valid) {
            if (valid) {
              self.isSaving = true;
              if (self.model.user_conditions.length > 0) {
                AccountApi.putUserConditions(self.model.user_conditions).then(function (response) {
                  if (self.model.user_medications.length > 0) {
                    MedicationsApi.postUserMedications(self.model.user_medications)
                      .then(function (response) {
                        AccountApi.putAccount(self.model)
                          .then(function (response) {
                            self.$gtag.event('HealthPanelComplete',{
                              'event_category': 'Onboarding',
                              'event_label': 'Completed health panel',
                              'value': 1
                            });
                            self.$router.push({
                              name: 'GettingStartedLocation'
                            });

                          })
                      })
                  }
                  else {
                    AccountApi.putAccount(self.model)
                      .then(function (response) {
                        self.isSaving = false;
                        self.$gtag.event( 'HealthPanelComplete',{
                          'event_category': 'Onboarding',
                          'event_label': 'Completed health panel',
                          'value': 1
                        });
                        self.$router.push({
                          name: 'GettingStartedLocation'
                        })
                      })
                  }
                })
              }

              if (self.model.user_medications.length > 0) {
                MedicationsApi.postUserMedications(self.model.user_medications)
                  .then(function (response) {
                    AccountApi.putAccount(self.model)
                      .then(function (response) {
                        self.$gtag.event( 'HealthPanelComplete',{
                          'event_category': 'Onboarding',
                          'event_label': 'Completed health panel',
                          'value': 1
                        });
                        self.$router.push({
                          name: 'GettingStartedLocation'
                        })
                      })
                  })
              }
              else {
                AccountApi.putAccount(self.model)
                  .then(function (response) {
                    self.isSaving = false;
                    self.$gtag.event('HealthPanelComplete',{
                      'event_category': 'Onboarding',
                      'event_label': 'Completed health panel',
                      'value': 1
                    });
                    self.$router.push({
                      name: 'GettingStartedLocation'
                    })
                  })
              }

            }
          })
      },
      forceUpdate () {
        let self = this;
        self.$forceUpdate()
      },
      yearList () {
        let years = 110, yearStartAt = new Date().getFullYear(), yearsArray = [];
        for (let i = 0; i < years; i++) {
          yearsArray.push('' + yearStartAt-- + '')
        }
        return yearsArray
      },
      handleConditionSearch (value) {
        let self = this;
        self.conditionSearching = true;
        MedicationsApi.conditionsGet(value, 10)
          .then(function (response) {
            self.conditionDataSource = [];
            for (let i = 0; i < response.data.length; i++) {
              const condition = {
                'condition_id': response.data[i].ID,
                'condition_label': response.data[i].title,
                'rightIcon': 'add'
              };
              self.conditionDataSource.push(condition)
            }
            self.conditionSearching = false
          })
          .catch(function (error) {
            self.conditionDataSource = [];
            self.conditionSearching = false
          })
      },
      handleConditionSelected (value) {
        let self = this;
        let object = _.filter(self.conditionDataSource, function (o) {
          return o.condition_label === value
        });
        let checkExists = _.filter(self.model.user_conditions, function (o) {
          return o.condition_label === value
        });
        if (checkExists.length === 0) {
          self.model.user_conditions.unshift(object[0]);
          self.$nextTick(function () {
            self.conditionSearchValue = '';
            self.conditionDataSource = [];
            self.forceUpdate()
          })
        }
        else {
          self.$nextTick(function () {
            self.conditionSearchValue = '';
            self.conditionDataSource = [];
            self.forceUpdate()
          })
        }
      },
      handleConditionRemoval (condition) {
        let self = this;
        let index = self.model.user_conditions.indexOf(condition);
        self.model.user_conditions.splice(index, 1)
      },
      handleMedicationSearch (value) {
        let self = this;
        self.medicationSearching = true;
        MedicationsApi.getTreatments(value)
          .then(function (response) {
            self.medicationDataSource = [];
            for (let i = 0; i < response.data.length; i++) {
              const medication = {
                'treatment_id': response.data[i].ID,
                'treatment_name': response.data[i].title,
                'rightIcon': 'add'
              };
              self.medicationDataSource.push(medication)
            }
            self.medicationSearching = false
          })
      },
      handleMedicationSelected (value) {
        let self = this;

        let object = self.medicationDataSource.filter(function (medication) {
          return medication.treatment_name == value
        });

        let checkExists = self.model.user_medications.filter(function (medication) {
          return medication.treatment_name == value
        });

        if (checkExists.length == 0) {
          self.model.user_medications.unshift(object[0]);
          self.$nextTick(function () {
            self.medicationHelpText = 'Add another medication';
            self.medicationSearchValue = '';
            self.medicationDataSource = [];
            self.forceUpdate()
          })
        }
        else {
          self.$nextTick(function () {
            self.medicationHelpText = 'You have already added that medication';
            self.medicationSearchValue = '';
            self.medicationDataSource = [];
            self.forceUpdate()
          })
        }
      },
      handleToggle (key) {
        let self = this;
        self.model[key] = !self.model[key];
        self.$forceUpdate()
      },
      reformatMedications () {
        let self = this;
        self.$forceUpdate();
        self.$nextTick(function () {
          let length = self.model.user_medications.length;
          for (let i = 0; i < length; i++) {
            let item = self.model.user_medications[i];
            if (_.has(item, 'frequency_id') && _.has(item, 'unit_id')) {
              item.frequency_label = self.getFrequencyLabelById(item.frequency_id);
              item.unit_label = self.getUnitLabelById(item.unit_id);
              self.$forceUpdate()
            }
          }
        })
      },
      getUnitLabelById (unit_id) {
        let self = this;
        return self.medicationUnitRegimes.filter(function (unit) {
          return unit.unit_id === unit_id
        })[0].unit_label
      },
      getFrequencyLabelById (frequency_id) {
        let self = this;
        return self.medicationFrequencyRegimes.filter(function (frequency) {
          return frequency.frequency_id === frequency_id
        })[0].frequency_label
      },
      handleMedicationDeleted (item) {
        let self = this;
        let index = self.model.user_medications.indexOf(item);
        self.model.user_medications.splice(index, 1);
        self.$forceUpdate()
      }
    }
  }
</script>


<style>
  #medication-list .mu-item-wrapper.hover {
    background-color: white !important;
  }

  #medication-list .mu-item {
    padding-top: 0px;
    padding-bottom: 0px;
    padding-left: 0;
    padding-right: 0
  }
</style>



// WEBPACK FOOTER //
// YourHealth.vue?9947ddd8